import { render } from "./ImportStock.vue?vue&type=template&id=2461741a&scoped=true&ts=true"
import script from "./ImportStock.vue?vue&type=script&lang=ts"
export * from "./ImportStock.vue?vue&type=script&lang=ts"

import "./ImportStock.vue?vue&type=style&index=0&id=2461741a&scoped=true&lang=css"

import exportComponent from "/Users/abdulkarim/workspace/public_html/joypurhost/pos2/pos2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2461741a"]])

export default __exports__